var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-descriptions',[(_vm.currentPluginVersion)?_c('el-descriptions-item',{attrs:{"label":"当前版本"}},[_vm._v(_vm._s(_vm.currentPluginVersion))]):_vm._e(),(_vm.newPluginVersion)?_c('el-descriptions-item',{attrs:{"label":"最新版本"}},[_vm._v(_vm._s(_vm.newPluginVersion))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }